import { DeviceService } from '../../../services/device.service'
import _ from 'lodash'
export default {
  methods: {
    canApprove(status, managerIdInventory) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_APPROVE') &&
        this.dataUser.userId === managerIdInventory
      )
    },
    canApproveGeneral(status, managerIdInventory) {
      return (
        status === 'SUCCESS' &&
        this.dataPermission.includes('CNPS_DEVICE_PURCHASE_ORDER_CREATE_FROM_TRANSFER_ORDER')
      )
    },
    canReject(status, managerIdInventory) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CHANGE_STATUS') &&
        this.dataUser.userId === managerIdInventory
      )
    },
    canCancel(status, userCreator, managerIdInventory) {
      return (
        ['NEW', 'APPROVED', 'MOVING'].includes(status) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CHANGE_STATUS') &&
        (this.dataUser.userId === managerIdInventory ||
          this.dataUser.username === userCreator.email)
      )
    },
    canCancelMoving(status, keeperIdConfirmImport) {
      return ['MOVING'].includes(status) && this.dataUser.userId === keeperIdConfirmImport
    },
    canEdit(status, userCreator) {
      return (
        status === 'NEW' &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_UPDATE') &&
        this.dataUser.username === userCreator.email
      )
    },
    canCoppy(status, userCreator) {
      return (
        ['REJECTED', 'CANCELLED', 'REJECT_IMPORT'].includes(status) &&
        this.dataUser.username === userCreator.email
      )
    },
    canApproveImport(status, keeperIdConfirmImport) {
      return (
        ['MOVING'].includes(status) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CHANGE_STATUS') &&
        this.dataUser.userId === keeperIdConfirmImport
      )
    },
    canRejectImport(status, keeperIdConfirmImport) {
      return (
        ['MOVING'].includes(status) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CHANGE_STATUS') &&
        this.dataUser.userId === keeperIdConfirmImport
      )
    },
    canApproveExport(data, userCreator) {
      return (
        (['APPROVED'].includes(data.status) ||
          (['TRANSFER_RETURN_FROM_AGENT'].includes(data?.reasonTransfer) &&
            ['NEW'].includes(data.status))) &&
        this.dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_CHANGE_STATUS') &&
        this.dataUser.username === userCreator.email
      )
    },
    async inTicket(id) {
      this.loading = true
      try {
        const res = await DeviceService.detailTransferWarehouse(id)
        const data = res.data
        const devicesGroup = _.groupBy(res.data.devices, 'categoryName')
        data.devicesGroup = Object.values(devicesGroup)
        data.timeImport = data.orderHistories.find(s => s.status === 'SUCCESS')?.dateCreate ?? 0
        await DeviceService.inTransferTicket({ data })
      } catch (error) {
      } finally {
        this.loading = false
      }
    },
    detailItem(id) {
      const routeData = this.$router.resolve({
        path: `/transfer-warehouse/detail/${id}`,
      })
      window.open(routeData.href, '_blank')
    },
    approveItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn duyệt phiếu điều chuyển ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.approveTransferWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Duyệt phiếu điều chuyển ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(`Duyệt phiếu điều chuyển ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    approveGenerateItem(item) {
      const h = this.$createElement
      const messageVNode = h('p', { class: 'f14' }, `Bạn có chắc chắn sinh phiếu đặt hàng không?`)
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.approveGeneralTransferWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(res.message || `Sinh phiếu đặt hàng thành công`)
              this.fetchData()
            } else this.showErr(res.message || `Sinh phiếu đặt hàng thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    rejectItem(item) {
      const h = this.$createElement
      const messageVNode = h('div', { class: 'form-group pos-relative' }, [
        h('textarea', { ref: 'rejectValue', class: 'form-control f12' }),
      ])
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lý do từ chối',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
          okDisabled: false,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.rejectTransferWarehouse({
              id: item.id,
              reasonReject: this.$refs.rejectValue.value,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Từ chối phiếu điều chuyển ${item.billNumber} thành công`)
              this.fetchData()
            } else {
              this.showErr(`Từ chối phiếu điều chuyển ${item.billNumber} thất bại`)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancelItem(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn huỷ phiếu điều chuyển ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelTransferWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.showSuccess(`Huỷ phiếu điều chuyển ${item.billNumber} thành công`)
              this.fetchData()
            } else this.showErr(`Huỷ phiếu điều chuyển ${item.billNumber} thất bại`)
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    editItem(id) {
      this.$router.push({
        path: `/transfer-warehouse/edit/${id}`,
      })
    },
    approveImport(id) {
      this.$router.push({
        path: `/transfer-warehouse/approve-import/${id}`,
      })
    },
    rejectImport(item) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn xác nhận không nhận được hàng cho ${item.quantityExport} thiết bị trong phiếu điều chuyển ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.rejectImportTransferWarehouse({
              id: item.id,
            })
            this.loading = false
            if (res.code === 1000) {
              this.keyCheck = 'accept'
              this.showSuccess(
                `Xác nhận không nhận được hàng cho phiếu ${item.billNumber} thành công`
              )
              this.fetchData()
            } else {
              this.keyCheck = 'cancel'
              this.showErr(res.message)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    cancelMoving(item, reasonReject) {
      const h = this.$createElement
      const messageVNode = h(
        'p',
        { class: 'f14' },
        `Bạn có chắc chắn xác nhận không nhận hàng cho ${item.quantityExport} thiết bị trong phiếu điều chuyển ${item.billNumber} không?`
      )
      this.$bvModal
        .msgBoxConfirm([messageVNode], {
          title: 'Lưu ý',
          okTitle: 'Xác nhận',
          cancelTitle: 'Huỷ',
          centered: true,
        })
        .then(async value => {
          if (value) {
            this.loading = true
            const res = await DeviceService.cancelMovingTransferWarehouse({
              id: item.id,
              reasonReject: reasonReject,
            })
            this.loading = false
            if (res.code === 1000) {
              this.keyCheck = 'accept'
              this.showSuccess(`Xác nhận không nhận hàng cho phiếu ${item.billNumber} thành công`)
              this.reasonReject = ''
              this.fetchData()
            } else {
              this.keyCheck = 'cancel'
              this.showErr(res.message)
            }
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    approveExport(id) {
      this.$router.push({
        path: `/transfer-warehouse/approve-export/${id}`,
      })
    },
    copyItem(coppyFrom) {
      this.$router.push({
        name: 'addTransferWarehouse',
        params: { coppyFrom },
      })
    },
  },
}
